export const selectOnDateOptions = [
    {value:"0", label: "Start Date"},  
    {value:"1", label: "Diary Date"}    
  ];